import { supabase } from './supabase';

export type LinkedTranscriptRow = {
  id: string;
  title: string;
  content: string;
  summary: string | null;
  meeting_date: string;
  participants: string[] | null;
  transcript_chunks_status?: string | null;
};

/**
 * Transcripts where any `participants[]` value contains the email (case-insensitive substring).
 * Handles entries like `"Name <email@domain.com>"` via DB function
 * `transcripts_for_participant_email`.
 */
export async function fetchTranscriptsByParticipantEmail(email: string): Promise<LinkedTranscriptRow[]> {
  const trimmed = email.trim();
  if (!trimmed) return [];

  const { data, error } = await supabase.rpc('transcripts_for_participant_email', {
    p_email: trimmed,
  });

  if (error) throw error;

  return (data ?? []) as LinkedTranscriptRow[];
}

export function transcriptPreview(row: LinkedTranscriptRow): string {
  const fromSummary = row.summary?.trim();
  if (fromSummary) return fromSummary;
  const c = row.content?.trim() ?? '';
  if (c.length <= 200) return c;
  return `${c.slice(0, 197)}…`;
}

export function transcriptChunksStatusLabel(status: string | null | undefined): string {
  switch (status ?? 'none') {
    case 'ready':
      return 'Ready';
    case 'pending':
      return 'Indexing…';
    case 'error':
      return 'Error';
    default:
      return 'Not indexed';
  }
}

export function formatTranscriptWhen(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return '—';
  }
}
